// extracted by mini-css-extract-plugin
export var ctaContainer = "columnized-content-module--ctaContainer--89ac3";
export var description = "columnized-content-module--description--fe9f0";
export var headline = "columnized-content-module--headline--da84c";
export var image = "columnized-content-module--image--4a3ed";
export var next = "columnized-content-module--next--86f20";
export var panel = "columnized-content-module--panel--d6426";
export var panelTitle = "columnized-content-module--panelTitle--f807f";
export var panelsContainer = "columnized-content-module--panelsContainer--89c0d";
export var prev = "columnized-content-module--prev--d4d41";
export var subtitle = "columnized-content-module--subtitle--a0ceb";
export var wrapper = "columnized-content-module--wrapper--325a9";